import { useToast } from "@chakra-ui/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import queryKey from "configs/queryKey";

import {
  UpdateTokenInfoParams,
  updateTokenInfoRequest,
} from "utils/apiService/tokenInfoRequest";

interface IProps {
  onClose: () => void;
  reset: () => void;
  id: string;
}
const useUpdateTokenInfo = ({ onClose, reset, id }: IProps) => {
  const toast = useToast();
  const queryClient = useQueryClient();
  return useMutation(
    async (params: UpdateTokenInfoParams) =>
      await updateTokenInfoRequest(id, params),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKey.TOKEN_INFO_REQUEST]);
        queryClient.invalidateQueries([queryKey.TOTAL_TOKEN_INFO_REQUEST]);

        onClose();
        reset();
        toast({
          title: "Token info",
          description: "Successfully",
          status: "success",
          duration: 2000,
          isClosable: true,
        });
      },
      onError: async (errors: any) => {
        const devMessage = errors?.response?.data?.devMessage || [];
        const errorMessage = errors?.response?.data?.errorMessage || "";
        const description = errorMessage + ":" + devMessage?.join(", ") || "";

        toast({
          title: "Token info",
          description,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      },
    }
  );
};

export default useUpdateTokenInfo;
